import type { HTTPError } from 'src/state/middleware/saga/handleHttpError'

// lobster-app が返す RFC9457 形式のエラーレスポンス
// https://www.rfc-editor.org/rfc/rfc9457.html
type LobsterApiErrorResponse = {
  type: 'about:blank'
  status: number
  title: string
  detail: string
}

const isLobsterApiErrorResponse = (
  body: unknown,
): body is LobsterApiErrorResponse => {
  if (typeof body !== 'object' || body === null) return false
  return (
    'detail' in body &&
    typeof (body as Record<string, unknown>)['detail'] === 'string'
  )
}

const isHTTPError = (body: unknown): body is HTTPError => {
  if (typeof body !== 'object' || body === null) return false
  const record = body as Record<string, unknown>
  const errors = record['errors']
  return (
    typeof record['status'] === 'number' &&
    typeof record['code'] === 'number' &&
    Array.isArray(errors) &&
    errors.length > 0 &&
    errors.every(e => typeof e === 'string')
  )
}

/**
 * Response オブジェクトからラベルマスタ API のエラーメッセージを取得する。
 *
 * /lobster/* は lobster-app から harami_api_server へ移行中で、環境によって
 * どちらの形式で返るか異なるため両対応する。
 * - lobster-app: RFC9457 形式の `detail`（優先）
 * - harami_api_server: `errors[0]`
 * 移行完了後は RFC9457 形式の分岐を削除する。
 * 取得できない場合は undefined を返す。
 */
export const getLobsterApiErrorDetail = async (
  error: unknown,
): Promise<string | undefined> => {
  if (!(error instanceof Response)) return undefined
  try {
    const body: unknown = await error.json()
    if (isLobsterApiErrorResponse(body)) return body.detail
    if (isHTTPError(body)) return body.errors[0]
  } catch {
    // JSON パース失敗時は undefined を返す
  }
  return undefined
}
